// extracted by mini-css-extract-plugin
module.exports = {"microsoftAdsRow":"ZK-z","microsoftAdsCard":"_K-z"};